/* __next_internal_client_entry_do_not_use__ MadeLocally auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { createSVGIcon } from "../../util";
export var MadeLocally = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M24.25 12.4809C24.25 17.0398 21.3066 21.2352 18.2165 24.3632C16.6863 25.912 15.1534 27.1656 14.0021 28.0321C13.4271 28.4649 12.9489 28.7999 12.616 29.0258C12.572 29.0557 12.5305 29.0836 12.4917 29.1096C12.4545 29.0856 12.4149 29.0599 12.373 29.0325C12.0407 28.8156 11.5632 28.4929 10.989 28.0738C9.8392 27.2347 8.30819 26.0143 6.77992 24.4883C3.69772 21.4108 0.75 17.2146 0.75 12.4809C0.75 6.00319 6.00957 0.75 12.5 0.75C18.9904 0.75 24.25 6.00319 24.25 12.4809Z",
            stroke: "currentColor",
            strokeWidth: "1.5"
        }),
        /*#__PURE__*/ _jsx("circle", {
            cx: "12.5",
            cy: "12.5",
            r: "5.75",
            stroke: "currentColor",
            strokeWidth: "1.5"
        })
    ]
}), "MadeLocally", {
    viewBox: "0 0 25 30",
    titleAccess: "MadeLocally",
    fill: "none"
});
